import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../css/Landing_page.css";

function LandingPage() {

    const navigate = useNavigate();

    useEffect(() => {

        const authed = localStorage.getItem("cwheels_user_isAuthenticated")

        if (authed != null) {

            console.log("JSON.parse(authed) is ", JSON.parse(authed))

            if (JSON.parse(authed)) {

                setTimeout(() => {
                    console.log("inside  navigate /home")
                    navigate("/home", { replace: true })
                }, 2000)
            } else {

                setTimeout(() => {
                    console.log("inside  navigate /login")
                    navigate("/login", { replace: true })
                }, 2000)
            }
        } else {

            console.log("JSON.parse(authed) is null", JSON.parse(authed))

            setTimeout(() => {
                console.log("inside  navigate /login")
                navigate("/login", { replace: true })
            }, 2000)
        }

    }, [])

    return (
        <div className="LandingPage-root-container page_background">
            <div class="spinner-border text-light" role="status">

            </div>

            <p>Checking Status</p>
        </div>
    )
}

export default LandingPage